import { render } from "./EmpresaView.vue?vue&type=template&id=fd500ed2&ts=true"
import script from "./EmpresaView.vue?vue&type=script&lang=ts"
export * from "./EmpresaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__